"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generateSlug;

var _formatSlug = _interopRequireDefault(require("./formatSlug"));

var _getParentSlug = _interopRequireDefault(require("./getParentSlug"));

function generateSlug(postType, postID, frontPage) {
  var _postType$posts;

  var trailingSlash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (postID === frontPage) {
    return trailingSlash ? '/' : '';
  }

  if (!(postType !== null && postType !== void 0 && (_postType$posts = postType.posts) !== null && _postType$posts !== void 0 && _postType$posts[postID])) {
    return '';
  }

  var postTypeSlug = postType.slug,
      posts = postType.posts,
      _postType$posts$postI = postType.posts[postID],
      postSlug = _postType$posts$postI.slug,
      parentID = _postType$posts$postI.parentID;
  var parentSlug = (0, _getParentSlug.default)(posts, parentID);
  var slug = (0, _formatSlug.default)("".concat(postTypeSlug, "/").concat(parentSlug, "/").concat(postSlug), trailingSlash);
  return slug;
}